mutation generateText($input: GenerateTextInput!) {
  generatedText: generateText(input: $input) {
    id
    choices
  }
}
